import { memo } from "react"

import { selectDisplayPosition } from "@/lib/storage/geolocation-selectors"
import { useAppSelector } from "@/lib/storage/hooks"
import { CustomMarker } from "@/components/map/custom-marker"
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip"

export const CurrentPositionMarker = memo(function CurrentPositionMarker() {
  const currentPosition = useAppSelector(selectDisplayPosition)
  if (!currentPosition) return null

  return (
    <CustomMarker
      position={{
        lat: currentPosition.latitude,
        lng: currentPosition.longitude,
      }}
      zIndex={3}
      title="Current location"
    >
      <Tooltip>
        <TooltipTrigger className="relative">
          {currentPosition.heading && (
            <div
              className="pointer-events-none absolute top-1/2 -left-1/3 size-6 origin-top"
              style={{
                background:
                  "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0) 85%)",
                clipPath: "polygon(50% -50%, 100% 100%, 0% 100%)",
                transform: `rotate(${360 - currentPosition.heading}deg)`,
              }}
            />
          )}
          <div className="relative size-4 rounded-full border-[3px] border-gray-1 bg-gray-12 text-gray-1" />
        </TooltipTrigger>
        <TooltipContent>Current location</TooltipContent>
      </Tooltip>
    </CustomMarker>
  )
})
